import { toast } from "sonner";
import i18next from "i18next";

/**
 * Displays validation errors as toast notifications
 * @param errors - Array of error messages to display
 */
export function showValidationErrors(errors: string[]): void {
  for (const error of errors) {
    toast.error(i18next.t("common:ValidationError"), {
      description: error,
    });
  }
}

/**
 * Validates form submission and shows errors if any exist
 * @param hasErrors - Whether validation errors exist
 * @param errors - Array of validation error messages
 * @param onValid - Callback executed if validation passes
 */
export function validateAndSubmit<T>(
  hasErrors: boolean,
  errors: string[],
  onValid: (values: T) => void,
): (values: T) => void {
  return (values: T): void => {
    if (hasErrors) {
      showValidationErrors(errors);
      return;
    }
    onValid(values);
  };
}
